"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHorizontalCursorBordersHelper = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var layout_border_1 = require("../../model/borders/layout-border");
var layout_table_border_1 = require("./borders/layout-table-border");
var TableHorizontalCursorBordersHelper = (function () {
    function TableHorizontalCursorBordersHelper() {
    }
    TableHorizontalCursorBordersHelper.getHorizontalCursorBorders = function (currTableColumnInfo) {
        var borders = [];
        list_1.ListUtils.forEach(currTableColumnInfo.tableRows, function (layoutRow, layoutRowIndex) {
            list_1.ListUtils.forEach(layoutRow.rowCells, function (layoutCell) {
                borders.push(TableHorizontalCursorBordersHelper.createHorizontalCursorBorder(currTableColumnInfo, layoutCell, layoutRowIndex));
            });
        });
        return TableHorizontalCursorBordersHelper.combine(borders);
    };
    TableHorizontalCursorBordersHelper.combine = function (borders) {
        var resultBorders = [];
        var prevBorder = borders[0];
        resultBorders.push(prevBorder);
        for (var brdIndex = 1, border = void 0; border = borders[brdIndex]; brdIndex++) {
            if (prevBorder.canCombine(border))
                prevBorder.length = border.xPos + border.length - prevBorder.xPos;
            else {
                prevBorder = border;
                resultBorders.push(prevBorder);
            }
        }
        return resultBorders.sort(function (a, b) { return a.yPos - b.yPos; });
    };
    TableHorizontalCursorBordersHelper.createHorizontalCursorBorder = function (currTableColumnInfo, cell, layoutRowIndex) {
        return new layout_table_border_1.LayoutCursorHorizontalTableBorder(cell.x - currTableColumnInfo.x, cell.bottom - currTableColumnInfo.y - TableHorizontalCursorBordersHelper.BORDER_HALF_WIDTH, cell.width, layout_border_1.LayoutBorder.getEmpty(), layoutRowIndex);
    };
    TableHorizontalCursorBordersHelper.BORDER_HALF_WIDTH = 2;
    return TableHorizontalCursorBordersHelper;
}());
exports.TableHorizontalCursorBordersHelper = TableHorizontalCursorBordersHelper;
